
function addCollapseListener(el) {
    let isCollapsed = true;

    const toggle = el.querySelector('[data-collapse-toggle]');
    const collapsed = el.querySelector('[data-collapse-collapsed]');
    const content = el.querySelector('[data-collapse-content]');

    toggle.addEventListener('click', () => {
        if (isCollapsed) {
            const h = content.scrollHeight;
            collapsed.style.height = `${h}px`;
            toggle.classList.add('question-item__toggle--expanded');

            isCollapsed = false;
        } else {
            collapsed.style.height = '0px';
            toggle.classList.remove('question-item__toggle--expanded');

            isCollapsed = true;
        }
    });
}

export default function initializeCollapse(selector) {
    document.querySelectorAll(selector).forEach((el) => {
        addCollapseListener(el);
    });
}
